/**
 * Firestore afviser felter med værdien undefined.
 * Denne hjælper fjerner dem, så delvise opdateringer altid kan gemmes.
 */
export function stripUndefined<T extends Record<string, unknown>>(data: T): T {
  const result: Record<string, unknown> = {}
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined) result[key] = value
  })
  return result as T
}
